import { Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill-new";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface AddWebinarProps {
    show: boolean;
    handleClose: () => void;
    data?: any;
}

type FormData = {
    title: string;
    date: string;
    time: string;
    duration: string;
    buttonText: string;
    link: string;
    topicForDiscussion: string;
    structure: string;
    id?: string;
}

const AddWebinar = ({ show, handleClose, data }: AddWebinarProps) => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<FormData>();
    const [isLoading, setLoading] = useState(false);
    const [topicForDiscussion, setTopicForDiscussion] = useState<string>("");
    const [structure, setStructure] = useState<string>("");

    useEffect(() => {
        if (data) {
            reset({
                title: data.title,
                date: data.date,
                time: data.time,
                duration: data.duration,
                buttonText: data.buttonText,
                link: data.link,
                topicForDiscussion: data.topicForDiscussion,
                structure: data.structure
            });
            setTopicForDiscussion(data.topicForDiscussion || "");
            setStructure(data.structure || "");
        } else {
            reset({
                title: "",
                date: "",
                time: "",
                duration: "",
                buttonText: "",
                link: "",
                topicForDiscussion: "",
                structure: ""
            });
            setTopicForDiscussion("");
            setStructure("");
        }
    }, [data])

    const onSubmit = (request: FormData) => {
        setLoading(true);
        request.topicForDiscussion = topicForDiscussion;
        request.structure = structure;
        if (data && data._id) {
            request['id'] = data._id;
            WebService.putAPI({
                action: `webinar/edit-webinar/${data._id}`,
                body: request
            })
                .then((res: any) => {
                    setLoading(false);
                    handleClose();
                    reset();
                    toast.success(res?.data?.message);
                })
                .catch((err: any) => {
                    setLoading(false);
                    toast.error(err?.response?.data?.message || err?.message);
                });
        } else {
            WebService.postAPI({
                action: `webinar/add-webinar`,
                body: request
            })
                .then((res: any) => {
                    setLoading(false);
                    handleClose();
                    reset();
                    toast.success(res?.data?.message);
                })
                .catch((err: any) => {
                    setLoading(false);
                    toast.error(err?.response?.data?.message || err?.message);
                });
        }
    }


    return (
        <div>
            <Offcanvas show={show} onHide={() => {
                handleClose();
            }}
                placement="end"
                className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{data ? 'Edit' : 'Add'}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-2" controlId="title">
                            <Form.Label className="label">Title</Form.Label>
                            <Form.Control type="text" placeholder="Enter title"
                                {...register("title", { required: 'Title is required' })} />
                            {errors.title && <div className="error-message">{errors.title.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="date">
                            <Form.Label className="label">Date</Form.Label>
                            <Form.Control type="date" placeholder="Enter date"
                                {...register("date", { required: 'Date is required' })} />
                            {errors.date && <div className="error-message">{errors.date.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="time">
                            <Form.Label className="label">Time</Form.Label>
                            <Form.Control type="time" placeholder="Enter time"
                                {...register("time", { required: 'Time is required' })} />
                            {errors.time && <div className="error-message">{errors.time.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="duration">
                            <Form.Label className="label">Duration</Form.Label>
                            <Form.Control type="text" placeholder="Enter duration"
                                {...register("duration", { required: 'Duration is required' })} />
                            {errors.duration && <div className="error-message">{errors.duration.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="topicForDiscussion">
                            <Form.Label className="label">Topic for Discussion</Form.Label>
                            <ReactQuill theme="snow" className="editor" value={topicForDiscussion} onChange={setTopicForDiscussion} />
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="structure">
                            <Form.Label className="label">Structure</Form.Label>
                            <ReactQuill theme="snow" className="editor" value={structure} onChange={setStructure} />
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="buttonText">
                            <Form.Label className="label">Button Text</Form.Label>
                            <Form.Control type="text" placeholder="Enter button text"
                                {...register("buttonText", { required: 'Button text is required' })} />
                            {errors.buttonText && <div className="error-message">{errors.buttonText.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="link">
                            <Form.Label className="label">Link</Form.Label>
                            <Form.Control type="text" placeholder="Enter link"
                                {...register("link", {
                                    required: 'Link is required',
                                    pattern: {
                                        value: /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/,
                                        message: 'Enter a valid URL'
                                    }
                                })} />
                            {errors.link && <div className="error-message">{errors.link.message}</div>}
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="d-flex justify-content-end p-3">
                    <CustomButton
                        isLoading={isLoading}
                        label="Save"
                        className="w-100"
                        onClick={handleSubmit(onSubmit)}
                    />
                </div>
            </Offcanvas>
        </div>
    );
};

export default AddWebinar;